import { Box, Modal } from "@mui/material";
import { IoClose } from "react-icons/io5";

const AttachmentModal = ({ open, setOpen, imgUrl }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className="flex items-center justify-center p-4"
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 3,
          width: "auto",
          maxWidth: "90vw",
          maxHeight: "85vh",
          overflow: "hidden",
        }}
        className="flex flex-col"
      >
        <div className="flex justify-between items-center px-4 py-3 border-b">
          <p className="text-lg font-semibold text-slate-700">Preview Gambar</p>
          <IoClose
            className="hover:text-red-600 cursor-pointer w-6 h-6 transition-transform duration-300 hover:rotate-90"
            onClick={handleClose}
          />
        </div>

        <div className="flex items-center justify-center bg-slate-50 p-4">
          <img
            src={imgUrl}
            alt="preview"
            className="max-w-full max-h-[70vh] object-contain rounded-lg"
          />
        </div>

        <div className="flex justify-end px-4 py-3 border-t">
          <button
            className="py-1.5 px-4 text-md text-slate-600 border border-slate-400 rounded-lg hover:bg-slate-100 transition-all duration-200"
            onClick={handleClose}
            type="button"
          >
            Tutup
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default AttachmentModal;
